export const getNestedValue = (key = '', obj) => {
  return key
    .split('.')
    .reduce((o, v) => (o && typeof o[v] !== 'undefined' ? o[v] : null), obj);
};

export const setNestedValue = (path, obj, value) => {
  const keys = path.split('.');
  const lastKey = keys.pop();
  const lastObj = keys.reduce((acc, key) => {
    if (!acc[key] || typeof acc[key] !== 'object') {
      acc[key] = {};
    }
    return acc[key];
  }, obj);
  lastObj[lastKey] = value;
};

export function searchFromValues(term, ...values) {
  if (
    !term ||
    typeof term !== 'string' ||
    !Array.isArray(values) ||
    !values.length
  ) {
    return true;
  }

  const searchTerm = term.toLowerCase();
  return values.some((v) => {
    if (typeof v !== 'string') return false;
    return v.toLowerCase().includes(searchTerm);
  });
}

export const scrollIntoFirstInvalidItem = (parentElement) => {
  if (!parentElement) return;

  let element = parentElement.elements?.item?.(0);
  for (var i = 1; element; element = parentElement.elements.item(i++)) {
    if (!element?.validity?.valid || element?.classList?.contains('is-invalid')) {
      element?.scrollIntoView({ behaviour: 'smooth', block: 'center' });
      element.focus();
      break;
    }
  }
};

export const getSchemaPathIds = (targetPath = '', schema) => {
  const result = [schema.fields.id]; // Add schema's root id always

  // Convert path like '$.realization.teachingLanguages[*].code' to array representation of paths, for example:
  // [
  //   '$',
  //   '$.realization',
  //   '$.realization.teachingLanguages',
  //   '$.realization.teachingLanguages[*]',
  //   '$.realization.teachingLanguages[*].code'
  // ]
  const targetParts = targetPath
    .split(/(\[\*\]|\.)/) // Split from '[*]' and '.'
    .filter(Boolean)
    .reduce(
      (a, c, idx, arr) =>
        c != '.' ? [...a, arr.slice(0, idx + 1).join('')] : a,
      []
    );

  const traverse = (fields, pathIdx, collectedIds) => {
    const currentPath = targetParts[pathIdx];
    for (const field of fields) {
      if (field.path === currentPath) {
        collectedIds.push(field.id);

        if (
          field.fields &&
          Array.isArray(field.fields) &&
          targetParts.length > pathIdx
        ) {
          traverse(field.fields, pathIdx + 1, collectedIds);
        }
      }
    }
  };

  traverse(schema.fields.fields, 1, result);
  return result;
};
